// Fuente única de verdad para el sistema de publicación por fases.
// Incrementar CURRENT_PHASE para activar nuevas páginas en nav y footer.
export const CURRENT_PHASE = 2;

export const NAV_LINKS_ALL = [
  { label: 'Plataforma', href: '/plataforma', fase: 1 },
  { label: 'Metodología', href: '/metodologia', fase: 1 },
  { label: 'Tecnología', href: '/tecnologia', fase: 1 },
  { label: 'SEO', href: '/seo', fase: 1 },
  { label: 'MCP', href: '/mcp', fase: 2 },
  { label: 'Sostenibilidad', href: '/sostenibilidad', fase: 1 },
  { label: 'Rankings', href: '/rankings', fase: 1 },
  { label: 'Planes', href: '/planes', fase: 2 },
  { label: 'Agencias', href: '/agencias', fase: 2 },
  { label: 'Nosotros', href: '/nosotros', fase: 2 },
];

export const FOOTER_LINKS_ALL = {
  Producto: [
    { label: 'Plataforma', href: '/plataforma', fase: 1 },
    { label: 'Metodología', href: '/metodologia', fase: 1 },
    { label: 'Tecnología', href: '/tecnologia', fase: 1 },
    { label: 'Servidor MCP', href: '/mcp', fase: 2 },
    { label: 'Planes', href: '/planes', fase: 2 },
    { label: 'Agencias', href: '/agencias', fase: 2 },
    { label: 'Suite SEO', href: '/seo', fase: 1 },
    { label: 'Sostenibilidad', href: '/sostenibilidad', fase: 1 },
  ],
  Recursos: [
    { label: 'Rankings por industria', href: '/rankings', fase: 1 },
    { label: 'Casos de estudio', href: '/casos', fase: 2 },
    { label: 'Glosario AEO', href: '/glosario', fase: 1 },
    { label: 'Guía definitiva', href: '/playbook', fase: 2 },
    { label: 'Blog', href: '/blog', fase: 2 },
    { label: 'Newsletter', href: '/newsletter', fase: 2 },
    { label: 'Comparativas', href: '/comparativas', fase: 2 },
  ],
  Empresa: [
    { label: 'Nosotros', href: '/nosotros', fase: 2 },
    { label: 'Contacto', href: '/contacto', fase: 2 },
    { label: 'Seguridad', href: '/seguridad', fase: 2 },
    { label: 'Privacidad', href: '/privacidad', fase: 1 },
    { label: 'Términos', href: '/terminos', fase: 1 },
    { label: 'Cookies', href: '/cookies', fase: 1 },
  ],
};

export const filterByPhase = (links, max = CURRENT_PHASE) =>
  links.filter((l) => l.fase <= max);

export const filterGroupsByPhase = (groups, max = CURRENT_PHASE) =>
  Object.fromEntries(
    Object.entries(groups)
      .map(([section, links]) => [section, filterByPhase(links, max)])
      .filter(([, links]) => links.length > 0)
  );
